import { render, staticRenderFns } from "./card-toggler.vue?vue&type=template&id=281b92c6&"
import script from "./card-toggler.vue?vue&type=script&lang=js&"
export * from "./card-toggler.vue?vue&type=script&lang=js&"
import style0 from "./card-toggler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./card-toggler.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports